
































































import { Component, Prop, Vue } from "vue-property-decorator";

/** true: change, false: delete */
@Component({})
export default class ChangeDeliteButtons extends Vue {
  @Prop({ type: String, default: null }) id!: string;
  @Prop({ type: String, default: "" }) size!: string;
  @Prop({ type: Boolean, default: true }) showTranslite!: boolean;
  @Prop({ type: Boolean, default: true }) showChange!: boolean;
  @Prop({ type: Boolean, default: true }) showDelet!: boolean;
  @Prop({ type: Boolean, default: false }) showRestore!: boolean;
}
